"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var React = _interopRequireWildcard(require("react"));

var _FilterLabel = _interopRequireDefault(require("../CampaignCreator/FilterLabel"));

var _helpers = require("../../helpers");

var _TagList = _interopRequireDefault(require("../CampaignCreator/TagList"));

var _reactRedux = require("react-redux");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PersonaFilterTagList = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(PersonaFilterTagList, _React$Component);

  function PersonaFilterTagList() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "handlePersonaClick", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee(persona) {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.props.removeSelectedPersona(persona);

              case 2:
                _context.next = 4;
                return _this.props.loadGroupedPersona();

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    return _this;
  }

  var _proto = PersonaFilterTagList.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        selectedPersonas = _this$props.selectedPersonas,
        theme = _this$props.theme,
        filters = _this$props.filters,
        _this$props$isDataPag = _this$props.isDataPage,
        isDataPage = _this$props$isDataPag === void 0 ? false : _this$props$isDataPag,
        resetTheme = _this$props.resetTheme,
        resetShareOfAttribute = _this$props.resetShareOfAttribute,
        resetShareOfAudience = _this$props.resetShareOfAudience,
        resetIndex = _this$props.resetIndex,
        resetPopulation = _this$props.resetPopulation,
        displaySegmentIds = _this$props.displaySegmentIds;
    var shareOfAttribute = filters.shareOfAttribute,
        shareOfAudience = filters.shareOfAudience,
        index = filters.index,
        population = filters.population;
    return /*#__PURE__*/React.createElement(_TagList["default"], null, selectedPersonas && selectedPersonas.map(function (persona, key) {
      return /*#__PURE__*/React.createElement(_FilterLabel["default"], {
        key: key,
        handleClick: function handleClick() {
          return _this2.handlePersonaClick(persona);
        },
        title: persona.name + " " + (displaySegmentIds ? persona.id : '')
      });
    }), !isDataPage && shareOfAttribute > 0 && /*#__PURE__*/React.createElement(_FilterLabel["default"], {
      handleClick: function handleClick() {
        return resetShareOfAttribute();
      },
      title: "Share of Attribute: " + shareOfAttribute + "%"
    }), !isDataPage && shareOfAudience > 0 && /*#__PURE__*/React.createElement(_FilterLabel["default"], {
      handleClick: function handleClick() {
        return resetShareOfAudience();
      },
      title: "Share of Audience: " + shareOfAudience + "%"
    }), !isDataPage && index > 0 && /*#__PURE__*/React.createElement(_FilterLabel["default"], {
      handleClick: function handleClick() {
        return resetIndex();
      },
      title: "Index: " + index
    }), !isDataPage && population > 0 && /*#__PURE__*/React.createElement(_FilterLabel["default"], {
      handleClick: function handleClick() {
        return resetPopulation();
      },
      title: "Population: " + (0, _helpers.formatAsThousands)(population)
    }), !isDataPage && theme.length > 0 && theme.map(function (themeRow) {
      return /*#__PURE__*/React.createElement(_FilterLabel["default"], {
        key: themeRow.categoryId,
        handleClick: function handleClick() {
          return resetTheme(themeRow.categoryId);
        },
        title: "Theme: " + themeRow.categoryLabel
      });
    }));
  };

  return PersonaFilterTagList;
}(React.Component); // get something out of global store


var mapStateToProps = function mapStateToProps(state, props) {
  return {
    displaySegmentIds: state.options.displaySegmentIds.value
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, null)(PersonaFilterTagList);

exports["default"] = _default;